import { ArrowDownRight, Hammer } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1660133373249-9e7b4de2efcf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxvdXRkb29yJTIwYmFycmVsJTIwc2F1bmElMjBuYXR1cmV8ZW58MHx8fHwxNzgzMzEwNzIxfDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-32 md:pt-40 pb-24 md:pb-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          <div className="lg:col-span-6 fade-up">
            <p className="overline mb-6">Indoor · Outdoor · Any Model</p>
            <h1 className="font-serif-display font-light text-text-main text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
              We assemble the sauna
              <br />
              <span className="italic text-cedar">you already bought.</span>
            </h1>
            <p className="mt-8 max-w-xl text-text-muted text-base md:text-lg leading-relaxed">
              From flat-pack indoor cabins to lakeside barrel saunas — our craftsmen handle
              delivery, precision assembly, and finishing details, so your investment arrives
              exactly as intended.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#book"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-2 rounded-full bg-cedar text-white hover:bg-cedar-hover px-8 py-4 font-accent text-sm tracking-wide transition-colors"
              >
                Request a Quote
                <ArrowDownRight size={16} strokeWidth={1.5} />
              </a>
              <a
                href="#portfolio"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-2 rounded-full border border-cedar text-cedar hover:bg-cedar hover:text-white px-8 py-4 font-accent text-sm tracking-wide transition-colors"
              >
                See recent installs
              </a>
            </div>

            <div className="mt-14 flex gap-12 max-w-lg">
              <div>
                <div className="font-serif-display text-4xl text-cedar">50+</div>
                <div className="overline mt-2 !text-text-muted">Assemblies</div>
              </div>
              <div>
                <div className="font-serif-display text-4xl text-cedar">Central Ohio</div>
                <div className="overline mt-2 !text-text-muted">Service Area</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 fade-up-delay-2">
            <div className="relative overflow-hidden rounded-2xl border border-[#E5E0D8] group">
              <img
                src={HERO_IMG}
                alt="Outdoor barrel sauna overlooking a calm lake"
                className="w-full h-[560px] md:h-[640px] object-cover img-zoom"
                data-testid="hero-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent pointer-events-none" />
              <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between text-white">
                <div className="flex items-center gap-3">
                  <Hammer size={16} strokeWidth={1.5} />
                  <span className="font-accent text-xs tracking-widest uppercase">
                    Columbus Home Sauna Installation
                  </span>
                </div>
                <span className="font-accent text-xs opacity-80">01 / 06</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
